import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

if (typeof window !== 'undefined') {
  (window as typeof window & { supabase?: typeof supabase }).supabase = supabase
}


export function generateCorrelationId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return Math.random().toString(36).substring(2, 15)
}

export async function invokeEdgeFunction<T = unknown>(
  functionName: string,
  options?: {
    headers?: Record<string, string>
    body?: any // eslint-disable-line @typescript-eslint/no-explicit-any
    method?: 'POST' | 'GET' | 'PUT' | 'PATCH' | 'DELETE'
    queryParams?: Record<string, string>
  }
) {
  const correlationId = generateCorrelationId()
  const headers = {
    ...options?.headers,
    'x-correlation-id': correlationId,
  }
  let targetName = functionName
  if (options?.queryParams) {
    const params = new URLSearchParams(options.queryParams)
    targetName += `?${params.toString()}`
  }
  return supabase.functions.invoke<T>(targetName, {
    ...options,
    headers,
  })
}

